const marketplaceUrl = 'https://marketplace.smarkets.com.br/';

export const environment = {
  production: true,
  appUrl: 'https://fup.smarkets.com.br/',
  apiUrl: 'https://fup-services.smarkets.com.br/api/',
  marketplaceUrl: marketplaceUrl,
  loginUrl: `${marketplaceUrl}auth/login`,
};
